module.exports = __webpack_public_path__ + "img/faresoner.2d300bb9.jpg";